/*
 * 功能名称: 功能描述
 * 创 建 人: 程天乐
 * 日    期: 2023-11-08 13:33:15
 */
import { FileApi } from "@newview/netsysconfig-api";
import { CustomHelper } from './CustomHelper';

interface IConfig {
    path?: string;
}
const fileinforApi: FileApi = new FileApi();
/**报表OSS缓存管理器 */
export class ReportOss {
    // 存储Token
    private _TOKEN: string = "";
    // 存储路径
    private _PATH: string = "/Report"
    // SKEY
    private _SKEY?: string = "230d0a013449356d8154abf0a8f7027c";

    /**
     * 所有方法的执行都必须经过此函数处理
     * @param method 
     */
    private validate(method: Function) {
        return new Promise(resolve => {
            if (CustomHelper.isNull(this._SKEY)) {
                console.log('SKey不能为空')
                resolve(null)
            }
            if (CustomHelper.isNull(this._TOKEN)) {
                console.log('Token不能为空，请调用初始化init方法！')
                resolve(null)
            }
            if (method) {
                resolve(method())
            }
        })
    }

    /**初始化 */
    init(token: string, config?: IConfig) {
        if (CustomHelper.isNull(token)) {
            console.log('token不能为空')
            return
        }
        this._TOKEN = token;
        if (config) {
            if (config.path) {
                this._PATH = config.path
            }
        }
    }

    /**上传 */
    upload(content: string) {
        return this.validate(async () => { 
            return CustomHelper.parseApiResult(await fileinforApi.WriteText(
                this._SKEY!,
                this._PATH,
                content,
                this._TOKEN
            ))
        })
    }

    /**下载 */
    download() {
        return this.validate(async () => {
            return CustomHelper.parseApiResult(await fileinforApi.ReadText(this._TOKEN))
        })
    }

    /**删除 */
    delete(token?: string) {
        if (token) {
            this.init(token)
        }
        return this.validate(async () => {
            return CustomHelper.parseApiResult(await fileinforApi.DeleteByToken(this._TOKEN))
        })
    }

    /**更新 */
    update(content: string) {
        return this.validate(async () => {
            this.delete()
            return this.upload(content)
        })
    }


}


